import { useMemo } from 'react';

interface Props {
    to: string;
    disabled?: boolean;
    className?: string;
    variant?: string;
    onClick?: () => void;
    children?: React.ReactNode;
}

export const ContentButtonLink = ({
    to,
    disabled,
    className,
    children,
    variant,
    onClick,
}: Props): React.ReactElement<any, any> | null => {
    const btnClassName = useMemo(() => {
        return `btn btn-${variant || 'primary'} ${className || ''} ${disabled ? 'disabled' : ''}`;
    }, [variant, className, disabled]);

    return (
        <a href={to} rel="noreferrer" target="_blank" className={btnClassName} onClick={onClick}>
            {children}
        </a>
    );
};
